@if(termsAndConditionsForm) {
<form [formGroup]="termsAndConditionsForm">
	@for (bundle of bundles; track bundle.agreement_bundle_version_id; ) {
	<div
		class="terms-and-conditions"
		[ngClass]="{
			wiggling:
				wiggleTerm && !termsAndConditionsForm.get(bundle.agreement_bundle_version_id).value && bundle.mandatory
		}">
		<div
			class="text"
			[innerHTML]="
				bundle.text
					| tcLinkReplace
						: {
								toReplace: toReplaceInLink,
								tradable: tradable,
								urlLeverageToken: urlLeverageToken
						  }
					| markdown
			"
			[ngClass]="{ 'light-color': lightColor }"
			(click)="toggle($event, bundle.agreement_bundle_version_id)"></div>
		@if (hasNoticeImplicitConsent) {
			@if (isTypeAgreement(bundle)) {
				<toggle-input-ui [formControlName]="bundle.agreement_bundle_version_id"></toggle-input-ui>
			}
		} @else {
			<toggle-input-ui [formControlName]="bundle.agreement_bundle_version_id"></toggle-input-ui>
		}
	</div>

	}
</form>
}
